<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Verhuur van de eigen woning
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Het gaat bij deze vraag om de tijdelijke verhuur van de eigen woning die niet te koop staat.</b>
                <div class="space10"></div>

                Verhuur je tijdelijk je eigen woning? Bijvoorbeeld tijdens je
                vakantie of een kort verblijf buiten Nederland? Dan blijft de woning ondanks de tijdelijke verhuur onder
                de eigenwoningregeling (box 1) vallen. Dat betekent dat je voor de periode inclusief
                de tijdelijke verhuur het volgende aangeeft:
                <li class="list">het eigenwoningforfait. Dit wordt berekend bij het onderdeel 'Woningen'</li>
                <li class="list">de aftrekbare (hypotheek)rente en financieringskosten. Deze vul je in bij het
                    onderdeel 'Financieringskosten'.
                </li>
                <li class="list">eventuele betalingen voor erfpacht, opstal of beklemming. Deze vul je in het bij het onderdeel
                    'Woningen'.
                </li>
                <div class="space10"></div>

                Daarnaast telt 70% van de ontvangen huur over de verhuurperiode mee als inkomsten uit tijdelijke
                verhuur. Dit berekenen wij voor je aan de hand van de hier ingevulde gegevens.
                <div class="space10"></div>

                <b>Ontvangen huur</b><br/>
                De 'ontvangen huur' is de berekende huurprijs, verminderd met bepaalde kosten. In de huurprijs
                mag je een vergoeding rekenen voor kosten die rechtstreeks samenhangen met de tijdelijke verhuur van de
                woning, bijvoorbeeld:
                <li class="list">gas- en elektriciteitsverbruik door de huurder</li>
                <li class="list">aan de huurder berekende kosten, zoals schoonmaken en wassen</li>
                <li class="list">advertenties en provisie</li>
                <div class="space10"></div>

                Onderhoudskosten, afschrijvingskosten en vaste lasten mag je niet aftrekken van de ontvangen huur.
                <div class="space10"></div>

                <b>Wat valt NIET onder inkomsten uit tijdelijke verhuur?</b><br/>
                <li class="list">de huur die je ontvangt bij verhuur van een deel van je eigen woning (bijvoorbeeld een kamer).
                    Afhankelijk van je situatie hebt je recht op de kamerverhuurvrijstelling. Deze vrijstelling geldt
                    alleen voor zover het verhuurde deel van de woning tot je eigen woning hoort.
                </li>
                <li class="list">de vergoeding die je ontvangt van kostgangers voor het schoonmaken en de maaltijden. Deze vergoeding
                    geeft je aan bij het onderdeel 'Overige inkomsten' als 'Resultaat overige werkzaamheden'.
                </li>
                <li class="list">de huur die kje ontvangt terwijl je zelf ergens anders woont, zoals bij uitzending of detachering.
                    In deze situatie valt de woning niet meer onder de eigenwoningregeling.
                </li>

                <div class="space10"></div>
                <b>Tijdelijke verhuur eigen woning via internet</b><br/>
                Het gaat hier ook om tijdelijke verhuur van de eigen woning via internet. Via verschillende websites
                kunt je je eigen woning tijdens de vakanties te huur aanbieden.

            </div>
        </div>
    </div>

</div>
